import React, { MouseEvent, FC } from 'react'
import Analytics from '@lib/Analytics'
import {
  ArticleLeadgenCardContainer,
  ArticleLeadgenCardContent,
  ArticleLeadgenCardSubtitle,
  ArticleLeadgenStyledCard,
  StyledButton,
  StyledFormWrapper,
  FormQuestionWrapper,
  BtnHelperText,
  ErrorText,
} from "@pages/Homepage/components/ArticleLeadgenCard/ArticleLeadgenCard.elements";
import {CardTitle} from "@css/common.elements";
import {useState} from "react";
import {validateQuestionInput} from "@lib/validators";
import {Question} from "@components/Question";
import {LeadgenPopupType} from "@components/LeadgenPopupFlow";

type Props = {
  title: string
  subtitle: string
  inputs: QuestionDataInput[]
  buttonHelpText: string
  buttonText: string
  onSubmit: (value?: string) => void
  leadgenPopupType?: LeadgenPopupType
}

export const ArticleLeadgenCard: FC<Props> = ({
  title,
  subtitle,
  inputs,
  buttonText,
  buttonHelpText,
  onSubmit,
  leadgenPopupType
}) => {

  const [value, setValue] = useState<string>('')
  const [error, setError] = useState<{
    key: string
    text: string
    answer: string
  }>()
  const [showError, setShowError] = useState<boolean>(false)
  const input = inputs[0]

  const handleChange = (_name: string, value: string) => {
    setValue(value)
    setError(undefined)
  }

  const handleSubmit = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    const error = validateQuestionInput(input, value)
    setError(error || undefined)

    if (!value || !!error) {
      Analytics.log('Form Error', { location: 'article-leadgen-widget', info: 'invalid zip' })
      setShowError(true)
    } else {
      Analytics.log('Click', { location: 'article-leadgen-widget', type: 'quote' })
      setShowError(false)
      if(leadgenPopupType){
        return onSubmit(leadgenPopupType)
      }
      onSubmit()
    }
  }

  return (
    <ArticleLeadgenCardContainer>
      <ArticleLeadgenStyledCard>
        <ArticleLeadgenCardContent>
          <CardTitle dangerouslySetInnerHTML={{__html: title}}/>
          <ArticleLeadgenCardSubtitle
            dangerouslySetInnerHTML={{__html: subtitle}}/>
          <StyledFormWrapper>
            <FormQuestionWrapper>
              <Question
                value={value}
                error={showError && !!error}
                inputData={input}
                onAnswerQuestion={handleChange}
                id="hero-question-2"
              />
              {showError && error && (
                <ErrorText>{value ? error.text : 'Please enter a value.'}</ErrorText>
              )}
            </FormQuestionWrapper>

            <StyledButton
              onClick={handleSubmit}
              variant="green"
              type="submit"
            >
              {buttonText}
            </StyledButton>

            <BtnHelperText>{buttonHelpText}</BtnHelperText>
          </StyledFormWrapper>

        </ArticleLeadgenCardContent>
      </ArticleLeadgenStyledCard>
    </ArticleLeadgenCardContainer>
  );
}
